import React from 'react';
import classNames from 'classnames';

const Loader = (props) => (
  <div className={classNames('loader', {
    'loading': props.loading,
    'loaded': props.loaded
  })}>
    <div className={'background'}/>
    <div className={'house'}/>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/parts/Loader.js